import "./App.css";
import React, { useState, useEffect } from "react";
import Header from "./Components/Pages/Header";
import Home from "./Components/Pages/Home";
import About from "./Components/Pages/About";
import Contact from "./Components/Pages/Contact";
import Blogpost from "./Components/Pages/Blogpost";
import Tutorialseries from "./Components/Pages/Tutorialseries";
import Footer from "./Components/Pages/Footer";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Readmore from "./Components/Pages/Readmore";
import Lessions from "./Components/Pages/Lessions";
import Tutorial from "./Components/Pages/Tutorial";
import Comment from "./Components/Pages/Comment";
import Searchpage from "./Components/Pages/Searchpage";
import NotFound from "./Components/Pages/NotFound";
import config from "./config/Config";
import AOS from "aos";

function AppLayout() {
  const [data, setData] = useState([]);
  const location = useLocation();

  function fetchConfiguration() {
    fetch(`${config.API_BLOG}configuration`)
      .then((result) => result.json())
      .then((res) => {
        setData(res);
      })
      .catch((err) => console.error("Error fetching configuration:", err));
  }

  useEffect(() => {
    fetchConfiguration();
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-out-cubic",
      once: true,
      offset: 48,
      delay: 0,
    });
  }, []);

  useEffect(() => {
    AOS.refresh();
  }, [location.pathname]);

  return (
    <>
      <Header data={data} />
      <main className="app-main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/read/:id" element={<Readmore />} />
          <Route path="/comment/:id" element={<Comment />} />
          <Route path="/less/:id" element={<Lessions />} />
          <Route path="/tutorial/:id" element={<Tutorial />} />
          <Route path="/blog" element={<Blogpost />} />
          <Route path="/blog/category/:id" element={<Blogpost />} />
          <Route path="/blog/tag/:tag" element={<Blogpost />} />
          <Route path="/blog/year/:year/month/:month" element={<Blogpost />} />
          <Route path="/tutorialseries" element={<Tutorialseries />} />
          <Route
            path="/tutorialseries/technology/:id"
            element={<Tutorialseries />}
          />
          <Route path="/search" element={<Searchpage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppLayout />
    </BrowserRouter>
  );
}
export default App;
